module.exports = __webpack_public_path__ + "static/media/mcmanus.62155a75.png";